import Box from '@mui/material/Box';
import { Dialog, TextV2 } from '@insights-ltd/design-library/components';
import { useTranslation } from 'react-i18next';

export type DownloadProgressDialogProps = {
  open: boolean;
  onClose: () => void;
  dialect?: string;
};

const baseUrl =
  import.meta.env.BASE_URL === '/' ? '' : import.meta.env.BASE_URL;

const DownloadProgressDialog = ({
  open,
  onClose,
  dialect,
}: DownloadProgressDialogProps) => {
  const { t } = useTranslation();
  const dialectString = dialect && t(dialect);
  const title = dialect
    ? t('ui.event-management.events.download-profiles.preparing-dialect', {
        dialect: dialectString,
      })
    : t('ui.event-management.events.download-profiles.preparing');

  return (
    <Dialog
      aria-labelledby="progress-dialog-title"
      aria-describedby="progress-dialog-description"
      open={open}
      onClose={onClose}
      content={
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            alignItems: 'center',
            justifyContent: 'space-between',
            textAlign: 'center',
          }}
        >
          <img
            src={`${baseUrl}/img/waiting_animation.gif`}
            alt="progress-graphic"
            width={200}
          />
          <Box
            sx={{
              paddingLeft: 4,
              paddingRight: 4,
            }}
          >
            <TextV2 variant="h3">{title}</TextV2>
            <TextV2 component="span">
              {t(
                'ui.event-management.events.download-profiles.preparing.message',
              )}
            </TextV2>
          </Box>
        </Box>
      }
    />
  );
};

export default DownloadProgressDialog;
